import React from 'react';
import * as Yup from 'yup';

import ReferenceDataProvider from '~/utils/reference-data/context';

import PredicateField from './PredicateField';
import NoteFormatterField from './NoteFormatterField';

const SubscriptionTopics = () => (
  <ReferenceDataProvider
    type="ReferenceTopic"
    config={{
      customFields: {
        predicates: {
          component: PredicateField,
          initialValue: '[]',
          normalizeValue: v => (v || '[]'),
          serializeValue: v => v,
          validationSchema: Yup.string().required('Predicates are required'),
        },
        noteFormatter: {
          component: NoteFormatterField,
          initialValue: '',
          normalizeValue: v => (v || ''),
          serializeValue: v => (v || null),
          validationSchema: Yup.string().nullable(),
        },
      },
    }}
  />
);

export default SubscriptionTopics;
